import { useContext, useEffect, useState } from "react";
import { AuthContext, AuthProvider } from "react-oauth2-code-pkce";
import { decodeJWT } from "react-oauth2-code-pkce/dist/decodeJWT";
import { useLocation } from "react-router-dom";

/* react-oauth2-code-pkce 라이브러리 홈페이지
   https://github.com/soofstad/react-oauth2-pkce */

const apiHost = process.env.REACT_APP_IMG_HOST; // API Server 개발서버, PROD URL
// const apiHost = 'http://127.0.0.1:3000'; // API Server Local
const authHost = process.env.REACT_APP_AUTH_HOST; // Seyfert 인증센터 URL
const authID = process.env.REACT_APP_AUTH_ID; // Client ID
// console.log(apiHost, authHost, authID)

const authConfig = {
  clientId: authID,
  authorizationEndpoint: `${authHost}/oauth2/authorize`,
  tokenEndpoint: `${authHost}/oauth2/token`,
  redirectUri: `${apiHost}/member-login`,
  scope: "openid profile",
  // logoutEndpoint: null,
  // logoutRedirect: null,
  // preLogin: () => null,
  // postLogin: () => null,
  decodeToken: false,
  authLogin: false,
  // extraAuthParameters: null,
  // extraTokenParameters: null,
  // extraAuthParams: null
};

const LoginInfo = ({ onResult, setStart }) => {
  // console.log("SignInWithSeyfert - loginInfo")
  const { tokenData, token, idToken, login, logOut, error, loginInProgress } =
    useContext(AuthContext);

  useEffect(() => {
    if (idToken) {
      onResult({
        idToken: idToken,
        decodeJWT: JSON.stringify(decodeJWT(idToken), null, 2),
      });
      setStart(false);
    }
  }, [idToken, onResult, setStart]);

  useEffect(() => {
    if (
      error &&
      error.startsWith(
        "Bad authorization state. Refreshing the page might solve the issue."
      )
    ) {
      login();
    }
  }, [error, login]);

  return null;
};

const SignInWithSeyfert = ({ onResult }) => {
  // console.log("SignInWithSeyfert 실행")
  const [start, setStart] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      setStart(true);
    }
  }, [location]);

  return start ? (
    <AuthProvider authConfig={authConfig}>
      <LoginInfo onResult={onResult} setStart={setStart} />
    </AuthProvider>
  ) : (
    <button
      type="button"
      className="btn sfrtBlue md round_10"
      onClick={() => {
        setStart(true);
      }}
    >
      Seyfert 인증센터로 로그인
    </button>
  );
};

export default SignInWithSeyfert;
